var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10.3125C12.4112 10.3125 10.3125 12.4112 10.3125 15C10.3125 17.5889 12.4112 19.6875 15 19.6875C17.5889 19.6875 19.6875 17.5889 19.6875 15C19.6875 12.4112 17.5889 10.3125 15 10.3125ZM12.1875 15C12.1875 13.4467 13.4467 12.1875 15 12.1875C16.5532 12.1875 17.8125 13.4467 17.8125 15C17.8125 16.5532 16.5532 17.8125 15 17.8125C13.4467 17.8125 12.1875 16.5532 12.1875 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.0625C9.35734 4.0625 5.55661 7.44275 3.35071 10.3086L3.31092 10.3603C2.81205 11.0082 2.35257 11.6049 2.04086 12.3105C1.70705 13.0661 1.5625 13.8896 1.5625 15C1.5625 16.1104 1.70705 16.9339 2.04086 17.6895C2.35257 18.3951 2.81205 18.9919 3.31094 19.6397L3.35071 19.6914C5.55661 22.5573 9.35734 25.9375 15 25.9375C20.6426 25.9375 24.4434 22.5573 26.6492 19.6914L26.689 19.6397C27.188 18.9919 27.6474 18.3951 27.9591 17.6895C28.293 16.9339 28.4375 16.1104 28.4375 15C28.4375 13.8896 28.293 13.0661 27.9591 12.3105C27.6474 11.6049 27.188 11.0082 26.689 10.3602L26.6492 10.3086C24.4434 7.44275 20.6426 4.0625 15 4.0625ZM4.83652 11.4523C6.8733 8.80615 10.1879 5.9375 15 5.9375C19.812 5.9375 23.1267 8.80615 25.1635 11.4523C25.7117 12.1645 26.0329 12.5901 26.244 13.0681C26.4415 13.515 26.5625 14.0611 26.5625 15C26.5625 15.9389 26.4415 16.485 26.244 16.9319C26.0329 17.4099 25.7117 17.8355 25.1635 18.5477C23.1267 21.1939 19.812 24.0625 15 24.0625C10.1879 24.0625 6.8733 21.1939 4.83652 18.5477C4.2883 17.8355 3.96717 17.4099 3.75595 16.9319C3.55855 16.485 3.4375 15.9389 3.4375 15C3.4375 14.0611 3.55855 13.515 3.75595 13.0681C3.96717 12.5901 4.28829 12.1645 4.83652 11.4523Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.24475f9176893a04b13c6d53f8239fa1.svg";
export { ForwardRef as ReactComponent };